/* eslint-disable @typescript-eslint/no-explicit-any */
import { get, handleClientError } from '../lib'

export type ResponseType =
  | {
      status: 'ok' | any //will be ok or is not ready
    }
  | any //since this will be used to echo for testing

//Note: for otheres, should pass through search filter
export const getOne = async (): Promise<ResponseType> => {
  return get<ResponseType>({
    path: '/test'
  })
}
